'use strict';

var App = require('app');
var AppState = require('app_state');
var DataInputView = require('components/devices/views/common/data_edit_dialog_view');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var BatchWriteRequest = require('models/modbus').BatchWriteRequest;

var ProgressInfoView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/batch_write_progress'),

    initialize: function (options) {
        this.saveOptions(options);
    },

    serializeData: function () {
        var total = parseInt(this.batchWriteJob.total);
        var success = this.batchWriteJob.success.length;
        var fail = this.batchWriteJob.fail.length;

        var data = {
            showProgress: this.showProgress,
            writing: this.writing,
            cancelled: this.cancelled,

            numTotal: total,
            numSuccess: success,
            numFail: fail,

            percentDone: 0,
            percentSuccess: 0,
            percentFail: 0,
        };

        if (parseInt(total)) {
            // re-calculate
            data.percentDone = Math.round((100 * (success + fail)) / total);
            data.percentSuccess = (100 * success) / total;
            data.percentFail = (100 * fail) / total;
        }

        return data;
    },

    saveOptions: function (options) {
        this.writing = options.writing;
        this.cancelled = options.cancelled;
        this.showProgress = options.showProgress;
        this.batchWriteJob = options.batchWriteJob;
    },

    update: function (options) {
        this.saveOptions(options);
        this.render();
    },
});

var BatchWriteDialogView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/common/batch_write_dialog'),

    ui: {
        selectedCategory: '#js-category-select',
        selectedValue: '#js-value-select',
        startWriting: '#js-btn-write',
        retry: '#js-btn-retry',
        cancel: '#js-btn-cancel',
        close: '#js-btn-close',
    },

    regions: {
        dataInputRegion: '#dataInput',
        progressInfoRegion: '#progressInfo',
    },

    events: {
        'change @ui.selectedCategory': 'onChangeCategory',
        'change @ui.selectedValue': 'onChangeValue',
        'click @ui.startWriting': 'startWriting',
        'click @ui.retry': 'retry',
        'click @ui.cancel': 'cancel',
        'click @ui.close': 'close',

        'click #cb-labels': function (e) {
            this.cbLabels = $(e.currentTarget).prop('checked');
            Misc.setVisible('#js-cb-label-content', this.cbLabels);
        },

        'input .js-label': function (e) {
            //remove forbidden characters
            e.currentTarget.value = e.currentTarget.value.replace(/[\<\>&\"\\\/´`'=\-;|]/gi, '');

            this.labelSuccess = $('#js-label-success')[0].value;
            this.labelFail = $('#js-label-fail')[0].value;
        },
    },

    valueFilter: {
        max: 1,
        readonly: false,
    },

    initialize: function (options) {
        this.controller = options.controller;
        (this.devices = options.collection.selected),
            this.controller.getUniqueSelectedTypes(this, this.devices, this.valueFilter);

        this.success = 0;
        this.fail = 0;

        this.inputValue = null;
        this.labelSuccess = this.labelFail = '';
    },

    serializeData: function () {
        var data = {
            writing: this.writing,
            categories: _.sortBy(_.values(this.deviceGroups.groups), 'name'),

            selectedCategoryID: this.selectedCategoryID,
            selectedValueID: this.selectedValueID,

            showLabels: this.cbLabels,
            labelSuccess: this.labelSuccess,
            labelFail: this.labelFail,

            values: [],
        };

        var valueModelsToItems = function (models, key) {
            models = models == undefined ? [] : models.toArray();

            var arr = [];
            _.each(models, function (e, i) {
                arr[i] = {
                    name: i18n.TR(e.attributes.name),
                    id: key + '_' + i,
                };
            });
            return arr;
        };

        if (this.values) {
            for (var key in this.values) {
                data.values.push({
                    name: key,
                    items: valueModelsToItems(this.values[key], key),
                });
            }
        }
        return data;
    },

    insertDataInputView: function () {
        if (!this.selectedValueID) {
            return;
        }

        var key = this.selectedValueID.split('_')[0];
        var idx = this.selectedValueID.split('_')[1];
        var model = this.values[key].toArray()[idx];

        var initialValue = this.inputValue;
        if (!initialValue) {
            var min = model.get('min');
            if (min <= 0 && model.get('max') > 0) {
                initialValue = 0;
            } else {
                initialValue = min;
            }
        }

        this.dataInputView = new DataInputView.Input({
            model: model,
            initValue: initialValue,
            controller: this.controller,
            disable: this.writing,
        });
        this.showChildView('dataInputRegion', this.dataInputView);
    },

    onChangeCategory: function () {
        this.selectedCategoryID = this.ui.selectedCategory.val();
        this.selectedValueID = undefined;

        this.showProgress = false;
        this.total = this.deviceGroups.groups[this.selectedCategoryID].deviceCount;

        this.controller.requestValues(this, this.valueFilter);
    },

    onChangeValue: function () {
        this.selectedValueID = this.ui.selectedValue.val();
        this.inputValue = null;
        this.showProgress = false;

        this.render();
    },

    retry: function (e) {
        this.done = false;
        this.startWriting(e, this.batchWriteJob.fail);
    },

    startWriting: function (e, devices) {
        Decorator.disableElement('.modal-dialog');

        var input = this.dataInputView;
        var form = Backbone.Syphon.serialize(input);

        this.batchWriteJob = new BatchWriteRequest({
            devices: devices ? devices : this.deviceGroups.groups[this.selectedCategoryID].devices,
            id: input.model.get('nr'),
            type: input.model.get('type'),
            value: input.mode == 'relative' ? parseInt(form.relativeValue) : parseInt(form.value || form.coil_select),
            value_ref: input.model.get('value_ref'),
            is_relative: input.mode == 'relative' ? 'true' : 'false',
            labelSuccess: this.cbLabels ? this.labelSuccess || '' : '',
            labelFail: this.cbLabels ? this.labelFail || '' : '',
        });

        var self = this;
        $.when(this.controller.createBatchWriteJob(this.batchWriteJob)).then(function (data) {
            self.writing = true;
            self.showProgress = true;
            self.cancelled = false; // reset!
            self.pollBatchWriteJob();

            $('#js-btn-cancel').text(i18n.TR('Schreibvorgang abbrechen'));
            $('#js-btn-cancel').removeClass('btn-primary').addClass('btn-white');
            Misc.setVisible('.js-hide-while-writing', false);
            Misc.setVisible('#js-btn-write', false);

            Decorator.enableElement('.modal-dialog');
        });
    },

    renderProgressView: function () {
        var options = {
            showProgress: this.showProgress,
            writing: this.writing,
            batchWriteJob: this.batchWriteJob,
            cancelled: this.cancelled,
        };

        if (!this.progressInfoView) {
            this.progressInfoView = new ProgressInfoView(options);
            this.showChildView('progressInfoRegion', this.progressInfoView);
        } else {
            this.progressInfoView.update(options);
        }
    },

    writingDone: function () {
        this.renderProgressView();

        var self = this;
        setTimeout(function () {
            self.writing = false;
            self.done = true;

            self.renderProgressView();

            $('#js-btn-cancel').removeClass('btn-white').addClass('btn-primary');
            Misc.setVisible('#js-btn-write', false);
            $('#js-btn-cancel').text(i18n.TR('Schließen'));
            Decorator.enableElement('.modal-dialog');
        }, 1000);
    },

    cancel: function (e) {
        if (this.writing) {
            Decorator.disableElement('.modal-dialog');

            this.cancelled = true;
            this.controller.cancelBatchWriteJob(this.batchWriteJob.jobID);

            e.stopPropagation(); // don't close dialog
            return;
        }

        if (this.done) {
            App.hideModal();
            if (this.controller.refreshPage) {
                this.controller.refreshPage();
            } else {
                Backbone.history.loadUrl(Backbone.history.fragment);
            }
            return;
        }
    },

    close: function (e) {
        if (this.writing) {
            this.controller.closeBatchWriteDialog(this.batchWriteJob.jobID);
        }
    },

    pollBatchWriteJob: function () {
        if (this.batchWriteJob && this.batchWriteJob.pending == false) {
            return;
        }

        var self = this;
        $.when(this.batchWriteJob.fetchProgress()).done(function () {
            // check is view is still active
            if (self.isDestroyed) {
                return;
            }

            self.renderProgressView();
            if (self.batchWriteJob.pending) {
                // function calls itself periodically as long as
                // our job is pending and the modal dialog exists
                setTimeout(self.pollBatchWriteJob.bind(self), 3000);
            } else {
                self.writingDone();
            }
        });
    },

    onRender: function () {
        Misc.setVisible('#js-cb-label-content', this.cbLabels);
        this.insertDataInputView();
        Misc.initSelectPicker();
    },

    onShow: function () {
        Misc.initSelectPicker();
    },
});

module.exports = BatchWriteDialogView;
